module.exports = __webpack_public_path__ + "img/31.b6b9782f.jpg";